import styled from 'styled-components';

export const ListItem = styled.li`
     background-color: #636363;
  margin-bottom: 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: .6em;
  border-radius: 2px;
  height: auto;
  transition: background-color 800ms ease, border 500ms ease-out;

  label {
      color: #fff;
  margin-bottom: 0;
  padding-left: 1em;
  width: 100%;
  padding: .75em 0;
  }

  .radio-button:checked{
      color: #ff0033;
  }

  :hover { background-color: #383838 !important;
  border: solid 2px #acff24;}
` 


// WEBPACK FOOTER //
// ./src/components/Admin/LessonBuilder/AssetCollections/AssetCollectionOption.styles.ts